<template>
    <k-page>
        <template v-slot:header>
            <profile-header/>
        </template>
        <k-container size="lg" class="pb-20 mt-8">
          <div class="mb-5" style="display: flex; justify-content: flex-end;">
                  <a-button type="primary" v-if="!$root.$data.investorProfile.vwoFeatures.goBackToReact.goBackToReactButtonHide" @click="this.$goBackToNewPlatform">Go back to new UI</a-button>
                </div>
            <div class="grid md:grid-cols-2 gap-3">
                <auto-invest-create :navigateParams="{name: 'autoinvestment-strategy', params: {}}"/>
                <auto-invest-faq/>
            </div>
            <auto-invest-strategies
                :items="autoInvestStrategies"
                :totalItems="autoInvestStrategies.length"
                @edit-strategy="editStrategy"
                @pause-strategy="pauseStrategy"
                @disable-strategy="disableStrategy"
                @activate-strategy="activateStrategy"
            />
        </k-container>
    </k-page>
</template>

<script>
    import ProfileHeader from '@investor/components/profile/ProfileHeader';
    import AutoInvestCreate from '@product-common/components/autoinvest/AutoInvestCreate';
    import AutoInvestFaq from '@product-common/components/autoinvest/AutoInvestFaq';
    import AutoInvestStrategies from '@product-common/components/autoinvest/AutoInvestStrategies';

    export default {
        components: {
            ProfileHeader,
            AutoInvestCreate,
            AutoInvestFaq,
            AutoInvestStrategies
        },
        data() {
            return {
                loading: false,
                autoInvestStrategies: [],
                form: {
                    ordering: [{
                        field: 'company_name',
                        asc: true,
                    }],
                    page: 1,
                    pageSize: 1000,
                },
            };
        },
        async mounted() {
            await this.refresh();
        },
        methods: {
            async refresh() {
                let resp = await this.$post('autoinvestment', this.form);
                this.autoInvestStrategies = resp.items;
            },
            async editStrategy(uuid) {
                this.$router.push({
                    name: 'autoinvestment-strategy',
                    params: { strategyUuid: uuid }
                });
            },
            async disableStrategy(uuid) {
                await this.$post(`autoinvestment/strategy/${uuid}`);
                await this.refresh();
            },
            async pauseStrategy(uuid) {
                await this.$post(`autoinvestment/strategy/${uuid}/pause`);
                await this.refresh();
            },
            async activateStrategy(uuid) {
                await this.$post(`autoinvestment/strategy/${uuid}/activate`);
                await this.refresh();
            },
        }
    };
</script>

<style scoped>
</style>


